module.exports = __webpack_public_path__ + "assets/img/earth.74700768.png";